<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
            <!-- Filter -->
            <div class="kt-form kt-form--label-right">
                <div class="row align-items-center">
                    <div class="col-xl-12 order-2 order-xl-1 pr-0">
                        <form class="row align-items-center" [formGroup]="form">
                            <div class="col-12 row pr-0">
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Group:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <input type="text" formControlName="group" placeholder="Group code or name" class="form-control">
                                </div>
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Sport Provider:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="game_provider_id" class="form-control">
                                        <option value="all"> All </option>
                                        <option [value]="value.game_provider_id" *ngFor="let value of dropdown.providers">{{ value.code }}</option>
                                    </select>
                                </div>
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Currency:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="currency_id" class="form-control">
                                        <option value="all"> All </option>
                                        <option [value]="value.id" *ngFor="let value of dropdown.currencies">{{ value.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Player:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <input type="text" formControlName="username" placeholder="Username" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 row pr-0 mt-2">
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Status:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="status" class="form-control">
                                        <option value="all"> All </option>
                                        <option [value]="value.id" *ngFor="let value of dropdown.statuses">{{ value.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Date:</label>
                                </div>
                                <div class="col-md-5 kt-form__control">
                                    <div class="input-group date">
                                        <div class="input-group-prepend">
                                            <select formControlName="date_type" class="form-control">
                                                <option [value]="value.id" *ngFor="let value of dropdown.dateTypes">{{ value.name }}</option>
                                            </select>
                                        </div>
                                        <input type="hidden" formControlName="start_datetime">
                                        <input type="hidden" formControlName="end_datetime">
                                        <input type="text" class="form-control" placeholder="Search" #dateRangeInput
                                            (change)="onDateRange($event)" formControlName="defaultDate"
                                            [timePicker]="true" [timePickerSeconds]="true"
                                            [alwaysShowCalendars]="true" [ranges]="ranges"
                                            [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                                            [timePicker24Hour]="true" [showDropdowns]="true"
                                            (click)="updateDateRange()" ngxDaterangepickerMd />
                                        <span class="input-group-append">
                                            <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Actions -->
            <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-3">
                <div class="dropdown dropdown-inline">
                    <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
                    <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
                </div>
                <div class="dropdown dropdown-inline">
                    <button *ngIf="canExport" class="btn btn-warning btn-icon-sm mr-2" (click)="onExport()" [disabled]="exportBtnLoading || loading">
                        <i [class]="exportBtnLoading ? 'spinner-border spinner-border-sm align-middle' : 'fas fa-file-download'"></i>Export
                    </button>
                    <button *ngIf="canCreate" class="btn btn-brand btn-icon-sm" (click)="onOpenSetup()">
                        <i class="fas fa-plus"></i>Create Group
                    </button>
                </div>
            </div>
            <!-- Table -->
            <div class="kt-section">
                <div class="kt-section__content">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover table-striped table-sortable border-separated">
                            <thead>
                                <tr>
                                    <th class="text-center sort-enabled" (click)="onSortColumn('id')" [ngClass]="sortingConfig.id" [class.sort-selected]="sortingSelection.sort_by === 'id'">ID</th>
                                    <th class="sort-enabled" (click)="onSortColumn('code')" [ngClass]="sortingConfig.code" [class.sort-selected]="sortingSelection.sort_by === 'code'">Group Code</th>
                                    <th class="sort-enabled" (click)="onSortColumn('name')" [ngClass]="sortingConfig.name" [class.sort-selected]="sortingSelection.sort_by === 'name'">Group Name</th>
                                    <th class="text-center">Sport Provider</th>
                                    <th class="text-center">Limit Mode</th>
                                    <th class="text-center">Currencies</th>
                                    <th class="text-center sort-enabled" (click)="onSortColumn('members_count')" [ngClass]="sortingConfig.members_count" [class.sort-selected]="sortingSelection.sort_by === 'members_count'">Players</th>
                                    <th class="text-center sort-enabled" (click)="onSortColumn('status')" [ngClass]="sortingConfig.status" [class.sort-selected]="sortingSelection.sort_by === 'status'">Status</th>
                                    <th class="date-column">Created By</th>
                                    <th class="date-column">Updated By</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="!loading">
                                <tr *ngFor="let row of tableRows" [class.default-row]="row.is_default">
                                    <td class="text-center">
                                        <i *ngIf="row.is_default; else groupId" class="fas fa-thumbtack default-icon"
                                            matTooltip="Provider default: applies to all players not in a group"></i>
                                        <ng-template #groupId>{{ row.id }}</ng-template>
                                    </td>
                                    <td><code>{{ row.code }}</code></td>
                                    <td>{{ row.name }}</td>
                                    <td class="text-center">{{ row.game_provider_code }}</td>
                                    <td class="text-center"><span class="kt-badge kt-badge--brand kt-badge--inline kt-badge--pill">{{ row.sport_count }} sports</span></td>
                                    <td class="text-center">
                                        <span *ngFor="let ccy of row.currencies" class="kt-badge kt-badge--unified-brand kt-badge--inline currency-tag">{{ ccy }}</span>
                                        <span *ngIf="row.currencies.length === 0" class="text-muted">Not set</span>
                                    </td>
                                    <td class="text-center">
                                        <ng-container *ngIf="!row.is_default; else allUnassigned">{{ row.members_count | number : '1.0' }}</ng-container>
                                        <ng-template #allUnassigned><small class="text-muted">All players not in a group</small></ng-template>
                                    </td>
                                    <td class="text-center">
                                        <span class="kt-badge kt-badge--inline kt-badge--pill" [ngClass]="row.status === 1 ? 'kt-badge--success' : 'kt-badge--danger'">{{ row.status_name }}</span>
                                    </td>
                                    <td>
                                        {{ row.created_by || '-' }}
                                        <ng-container *ngIf="row.created_at">
                                            <br />
                                            <span placement="top" [ngbTooltip]="createdDateTime" container="body" class="text-ellipsis">{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                            <ng-template #createdDateTime>
                                                {{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                            </ng-template>
                                        </ng-container>
                                    </td>
                                    <td>
                                        {{ row.updated_by || '-' }}
                                        <ng-container *ngIf="row.updated_at">
                                            <br />
                                            <span placement="top" [ngbTooltip]="updatedDateTime" container="body" class="text-ellipsis">{{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                            <ng-template #updatedDateTime>
                                                {{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                            </ng-template>
                                        </ng-container>
                                    </td>
                                    <td class="text-center text-nowrap">
                                        <ng-container *ngIf="canEdit">
                                            <button matTooltip="Edit Group" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm" (click)="onOpenSetup(row, 0)"><i class="fas fa-edit"></i></button>
                                            <button matTooltip="Bet Limits" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm" (click)="onOpenSetup(row, 1)"><i class="fas fa-dollar-sign"></i></button>
                                            <button [matTooltip]="row.is_default ? 'A provider default has no players' : 'Players'" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm" [disabled]="row.is_default" (click)="onOpenSetup(row, 2)"><i class="fas fa-users"></i></button>
                                        </ng-container>
                                        <button *ngIf="canDelete" [matTooltip]="row.is_default ? 'A provider default cannot be deleted' : 'Delete Group'" class="btn btn-outline-hover-danger btn-elevate btn-sm btn-icon btn-icon-sm" [disabled]="row.is_default" (click)="onDelete(row)"><i class="fas fa-trash-alt"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
                        </table>
                    </div>
                    <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                        <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize"
                            [directionLinks]="true" [boundaryLinks]="true" [rotate]="true"
                            [collectionSize]="pagination.total" (pageChange)="onViewPageBy(page)">
                        </ngb-pagination>
                        <div class="kt-pagination__toolbar">
                            <select (change)="onPerPage($event)" [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
                                class="form-control kt-font-brand page-size">
                                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                            </select>
                            <span class="pagination__desc">
                                Showing {{ pagination.from || 0 }} to {{ pagination.to || 0 }} of
                                {{ pagination.total | number : '1.0' }} records
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<kt-swal-alert [message]="messages$ | async"></kt-swal-alert>
